export function monthsFrom(lastClosed: Date | string, t: number): Date {
    const base =
        typeof lastClosed === 'string'
            ? parseMonthEnd(lastClosed)
            : new Date(lastClosed.getFullYear(), lastClosed.getMonth(), lastClosed.getDate());

    const year = base.getFullYear();
    const month = base.getMonth() + t;
    return monthEndFromParts(year, month);
}

export function daysInMonth(lastClosed: Date | string, t: number): number {
    const end = monthsFrom(lastClosed, t);
    return end.getDate();
}

function parseMonthEnd(value: string): Date {
    const part = value.trim().split('T')[0] ?? value;
    if (/^\d{4}-\d{2}-\d{2}$/.test(part)) {
        const [y, m, d] = part.split('-').map(Number);
        return new Date(y as number, (m as number) - 1, d as number);
    }
    throw new Error(`Invalid month-end date: ${value}`);
}

export { parseMonthEnd };

function monthEndFromParts(year: number, monthIndex: number): Date {
    const normalizedYear = year + Math.floor(monthIndex / 12);
    const normalizedMonth = ((monthIndex % 12) + 12) % 12;
    return new Date(normalizedYear, normalizedMonth + 1, 0);
}

export function monthKeyFromT(lastClosed: string, t: number): string {
    if (!lastClosed.trim()) {
        return '';
    }
    const end = monthsFrom(lastClosed, t);
    const month = String(end.getMonth() + 1).padStart(2, '0');
    return `${end.getFullYear()}-${month}`;
}

export function tFromMonthKey(lastClosed: string, month: string): number | null {
    for (let t = 1; t <= 36; t += 1) {
        if (monthKeyFromT(lastClosed, t) === month) {
            return t;
        }
    }
    return null;
}
